import React, { createContext, useReducer, useState, ReactNode } from 'react';

export const AuthContext = createContext<any | undefined>(undefined);

interface AuthState {
  user: any;
  token: string | null;
  expiration: string | null;
  refreshToken: string | null;
  name: string;
}

interface AuthAction {
  type: string;
  payload?: any; 
}

const initialState: AuthState = {
  user: null,
  token: null,
  expiration: null,
  refreshToken: null,
  name: ''
}

const authReducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...state,
        token: action.payload.token,
        expiration: action.payload.expiration,
        refreshToken: action.payload.refreshToken,
      };
    case 'SET_USER':
      return {
        ...state,
        name: action.payload.name,
      };
    case 'LOGOUT':
      return initialState;
    default:
      return state;
  }
}

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);

  const login = (token: string, expiration: string, refreshToken: string): void => {
    dispatch({
      type: 'LOGIN',
      payload: { token, expiration, refreshToken },
    });
  };

  const setUser = (name: string): void => {
    dispatch({
      type: 'SET_USER',
      payload: { name },
    });
  };

  const logout = (): void => {
    localStorage.removeItem('token');
    dispatch({ type: 'LOGOUT' }); // No payload needed for LOGOUT
  };

  return (
    <AuthContext.Provider value={{ ...state, login, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
